
const ACTIVE = 'ACTIVE';
const INACTIVE = 'INACTIVE';

const CERTIFIED = 'CERTIFIED';
const PENDING = 'PENDING';
const SUSPENDED = 'SUSPENDED';

const ON = 'ON';
const OFF = 'OFF';

export const ACTIVITY_TYPES = {
    ACTIVE,
    INACTIVE 
};

export const CERTIFICATION_TYPES = {
    CERTIFIED,
    PENDING,
    ACTIVE,
    SUSPENDED
};

export const SLIDER_ACTIVITY_TYPES = {
    ON,
    OFF
};

export const USER_PROFILE = {
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
    INACTIVE_DORMANT: 'Inactive-dormant',
    LOCKED: 'Locked',
    ENABLED: 'Enabled'
};